import { render, staticRenderFns } from "./SwipePlugin.vue?vue&type=template&id=0b510ea2&scoped=true"
import script from "./SwipePlugin.vue?vue&type=script&lang=ts"
export * from "./SwipePlugin.vue?vue&type=script&lang=ts"
import style0 from "./SwipePlugin.vue?vue&type=style&index=0&id=0b510ea2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b510ea2",
  null
  
)

export default component.exports